<template>
  <v-container
    class="fill-height"
    v-if="promotion && promotion.id && promotionDeadlines && !isAfterAllSubmissionDeadlines"
  >
    <v-row justify="center">
      <v-col lg="8" md="10" sm="10" xs="12">
        <v-form @submit.stop.prevent="onSubmit" auto-complete="no">
          <v-card class="elevation-12">
            <v-toolbar color="info" dark flat>
              <v-toolbar-title>
                <span>{{ finalTitle }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on: on }">
                  <v-btn icon v-on="on" :to="{ name: 'ceurLanding' }">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.translate("Cancel") }}</span>
              </v-tooltip>
            </v-toolbar>

            <v-card-text>
              <ApiError :errors="errors"></ApiError>

              <v-stepper v-model="e1">
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-form @submit.prevent="onSubmit" v-model="valid">
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              name="firstName"
                              :label="this.$i18n.translate('First Name')"
                              id="firstName"
                              v-model="form.user.firstName"
                              :rules="rules.firstName"
                              :error-messages="$error.getValidationError(errors, 'firstName')"
                              @input="$error.clearValidationError(errors, 'firstName')"
                              autocomplete="no"
                              class="required"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              name="lastName"
                              :label="this.$i18n.translate('Last Name')"
                              id="lastName"
                              v-model="form.user.lastName"
                              :rules="rules.lastName"
                              :error-messages="$error.getValidationError(errors, 'lastName')"
                              @input="$error.clearValidationError(errors, 'lastName')"
                              autocomplete="no"
                              class="required"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <EmailField
                              name="email"
                              :label="this.$i18n.translate('Email')"
                              id="email"
                              v-model="form.user.email"
                              :rules="rules.email"
                              :error-messages="$error.getValidationError(errors, 'email')"
                              @input="$error.clearValidationError(errors, 'email')"
                              autocomplete="no"
                              class="required"
                            ></EmailField>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <TermsAndConditionsView
                              :value="termsAndConditions"
                              @update:valid="validTermsAndConditions = $event"
                          /></v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <p>
                              By clicking 'Register' below, I agree to the Sony Electronics Inc.
                              <a href="https://electronics.sony.com/privacy-policy" target="_blank" rel="noreferrer"
                                >Privacy Policy
                              </a>
                              and certify that I am a U.S. resident.
                              <a
                                href="https://electronics.sony.com/privacy-policy#DataPractices"
                                target="_blank"
                                rel="noreferrer"
                                >CA Privacy Notice</a
                              >
                            </p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn color="secondary" @click="backToLanding()">
                              Cancel
                            </v-btn>
                          </v-col>
                          <v-col class="text-right">
                            <v-btn
                              color="primary"
                              @click="onSubmit()"
                              :loading="loading"
                              :disabled="!valid || !validTermsAndConditions"
                            >
                              Register
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <p>*Email will be sent from ConsumerRebatesHq@rebatesupport.com</p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <p v-html="finalDescription"></p>
                    <v-row v-if="!success">
                      <v-col>
                        <v-btn color="primary" @click="onBack()">
                          Back
                        </v-btn>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn color="secondary" @click="backToLanding()">
                          Cancel
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row v-else>
                      <v-col class="text-right">
                        <v-btn color="primary" @click="backToLanding()">
                          Finish
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <div class="white--text text-center">
      <p class="mb-5"></p>
      <h2>{{ noPromotionsMessage }}</h2>
      <p class="mb-5"></p>
    </div>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import Vue from "vue";
import { mapGetters } from "vuex";
import TermsAndConditionsView from "../../gapp-components/components/display/TermsAndConditionsView.vue";
import EmailField from "../../gapp-components/components/fields/EmailField.vue";

export default {
  components: { EmailField, TermsAndConditionsView },
  name: "CeurImagingEdge",
  metaInfo: {
    title: "Imaging Edge"
  },
  data() {
    return {
      loading: false,
      e1: 1,
      errors: {},
      errorMessage: null,
      promotionKey: "EDGE202306",
      success: false,
      valid: false,
      validTermsAndConditions: false,
      noPromotionsMessage: this.$i18n.translate("Check back with us soon for new rebates!"),
      promotion: {},
      rules: {
        firstName: [v => !!v || "First Name is required."],
        lastName: [v => !!v || "Last Name is required."],
        country: [v => (!!v && !!v.name) || "Country is required."],
        email: [v => !!v || "E-mail is required"],
        terms: [v => !!v || "Terms and Conditions are required"]
      },
      form: {
        programKey: process.env.VUE_APP_PROGRAM_CEUR_KEY,
        clientKey: process.env.VUE_APP_CLIENT_KEY,
        participantStatus: {},
        user: {
          firstName: "",
          lastName: "",
          email: "",
          username: ""
        },
        participant: {
          email1: "",
          phoneNumber1: "",
          address: {
            address1: "",
            address2: "",
            country: {},
            region: {},
            city: "",
            postalCode: ""
          },
          participantStatus: { name: "PRE" },
          termAndConditionAccepted: false
        },
        relationships: [],
        sendMail: true
      },
      program: null,
      finalDescription: "",
      termsAndConditions: {},
      finalTitle: "You must register here to receive the Rebate Offer via email",
      promotionDeadlines: []
    };
  },
  beforeCreate() {
    let promotionKey = "EDGE202306";
    this.$sonyProgram
      .fetchPublicPromotionByKey(promotionKey, this.selectedProgram.programKey)
      .then(data => {
        Vue.set(this, "promotion", data.promotion);
        Vue.set(this, "promotionDeadlines", data.promotionDeadlines);
      })
      .catch(() => {
        Vue.set(this, "promotion", {});
        console.log("Unable to load promotion");
      })
      .finally(() => {
        this.loading = false;
      });
  },
  created() {
    // clear existing errors
    this.$store.dispatch("logout");
    this.getTermsAndConditions();
  },
  computed: {
    ...mapGetters(["selectedLocale", "selectedProgram"]),
    isAfterAllSubmissionDeadlines() {
      if (!this.promotionDeadlines) return false;
      let currentDate = moment();

      for (let i = 0; i < this.promotionDeadlines.length; i++) {
        let deadlineDate = moment(this.promotionDeadlines[i].submissionDeadlineDate);

        if (currentDate.isSameOrBefore(deadlineDate)) {
          return false;
        }
      }

      return true;
    }
  },
  methods: {
    async onSubmit() {
      //Set loading spinner
      this.loading = true;
      this.errors = {};
      this.errorMessage = null;
      Vue.set(this, "errors", []);

      // clear existing errors
      this.$store.dispatch("logout");

      // Preparing the form
      var postForm = {};
      postForm.program = { id: this.selectedProgram.id };
      postForm.promotionKey = this.promotionKey;
      postForm.participant = this.form.participant;
      postForm.participant.participantType = this.selectedProgram.defaultOnEnrollParticipantType;
      postForm.participant.user = this.form.user;
      postForm.participant.email1 = this.form.email;
      postForm.participant.organization = this.form.organization;
      postForm.participant.address.country = { name: "USA" };

      // Sending the request
      this.$api
        .postWithCaptcha("/api/promotionInvitations/selfInvitation/public", postForm, null, "ImagingEdgeRegister")
        .then(() => {
          this.e1 = 2;
          this.finalTitle = "Your Registration was successful.";
          this.finalDescription =
            "An email will be sent shortly to the email address you have provided on the form." +
            "<br><br>" +
            "Thank you for choosing Sony! <br><br>";
          this.success = true;
        })
        .catch(error => {
          let errorDescription = "";
          errorDescription = this.$api.getErrorsFromResponse(error).message;
          this.e1 = 2;
          this.finalTitle = "Registration error";
          this.finalDescription = errorDescription.startsWith("The user is already registered")
            ? "The email address you have provided has already been registered. Please call 1.888.793.1332 and request the email resent. <br><br> Thank you for choosing Sony!"
            : errorDescription;
          this.success = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    backToLanding() {
      this.$router.push({ name: "ceurLanding" });
    },

    onBack() {
      this.finalTitle = "You must register here to receive the Rebate Offer via email";
      this.e1 -= 1;
    },
    getTermsAndConditions() {
      let selectedLocaleName =
        this.selectedLocale && this.selectedLocale.languageType ? this.selectedLocale.languageType.name : "en";
      this.$sonyProgram.fetchPublicPromotionByKey(this.promotionKey, this.selectedProgram.programKey).then(data => {
        if (
          data &&
          data.promotion &&
          data.promotion.promotionType &&
          data.promotion.promotionType.termsAndConditions.length > 0
        ) {
          let termsAndConditions = data.promotion.promotionType.termsAndConditions.filter(
            tac => tac.language.name == selectedLocaleName
          );
          if (termsAndConditions.length > 0) {
            this.termsAndConditions = termsAndConditions[0];
          }
        }
      });
    }
  }
};
</script>
<style>
.grecaptcha-badge {
  bottom: 40px !important;
}
</style>
